import React from 'react';
import { motion } from 'framer-motion';
import { Star, TrendingUp, Briefcase } from 'lucide-react';
export function TestimonialsSection() {
  return <section className="py-24 px-4 relative" data-id="element-224">
      <div className="max-w-5xl mx-auto" data-id="element-225">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-226">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-227">
            They Hacked The Algorithm.{' '}
            <span className="text-gold" data-id="element-228">Now It's Your Turn.</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-229">
          {/* Testimonial 1 */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.5
        }} className="bg-gradient-to-b from-[#1a1a24] to-[#0d0d14] p-8 rounded-2xl border border-gold/20 shadow-gold-glow relative" data-id="element-230">
            <div className="flex gap-1 mb-6" data-id="element-231">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold text-gold" data-id="element-232" />)}
            </div>
            <p className="text-lg text-gray-300 italic mb-8 leading-relaxed" data-id="element-233">
              "I went from a 540 score to a 735 in just 38 days. I thought
              medical collections would haunt me forever, but with the 'Data
              Inhibition' method in this book, they vanished from my report like
              magic. Last week, I got approved for my first Amex Gold!"
            </p>
            <div className="flex items-center justify-between border-t border-white/10 pt-6" data-id="element-234">
              <div data-id="element-235">
                <p className="font-bold text-white" data-id="element-236">Kevin R.</p>
                <p className="text-sm text-gray-500" data-id="element-237">Miami, FL</p>
              </div>
              <div className="bg-green-900/30 border border-green-500/30 px-3 py-1.5 rounded-lg flex items-center gap-2" data-id="element-238">
                <TrendingUp className="w-4 h-4 text-green-400" data-id="element-239" />
                <span className="text-green-400 font-semibold text-sm" data-id="element-240">
                  +195 points in 5 weeks
                </span>
              </div>
            </div>
          </motion.div>

          {/* Testimonial 2 */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-gradient-to-b from-[#1a1a24] to-[#0d0d14] p-8 rounded-2xl border border-gold/20 shadow-gold-glow relative" data-id="element-241">
            <div className="flex gap-1 mb-6" data-id="element-242">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold text-gold" data-id="element-243" />)}
            </div>
            <p className="text-lg text-gray-300 italic mb-8 leading-relaxed" data-id="element-244">
              "As a business owner, I needed capital. Thanks to the Business
              Credit 2026 guide, I secured $35,000 at 0% interest under my LLC.
              I no longer use my personal credit for my business. This book is
              worth 100x the price!"
            </p>
            <div className="flex items-center justify-between border-t border-white/10 pt-6" data-id="element-245">
              <div data-id="element-246">
                <p className="font-bold text-white" data-id="element-247">Sonia M.</p>
                <p className="text-sm text-gray-500" data-id="element-248">Houston, TX</p>
              </div>
              <div className="bg-blue-900/30 border border-blue-500/30 px-3 py-1.5 rounded-lg flex items-center gap-2" data-id="element-249">
                <Briefcase className="w-4 h-4 text-electric-blue" data-id="element-250" />
                <span className="text-electric-blue font-semibold text-sm" data-id="element-251">
                  $35k Business Credit
                </span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}